module.exports = __webpack_public_path__ + "img/图片2.0bf75f25.jpg";